import { IState } from "../reducers";
import { IChangeRequest } from "../../common/services/contracts/changerequest.contract";
import { IChangeRequestsState } from "./change-requests.reducer";

export const getChangeRequestsState = (store: IState): IChangeRequestsState => store.changeRequests;
export const getChangeRequests = (store: IState): IChangeRequest[] => getChangeRequestsState(store).changeRequests;
export const getChangeRequestsLoading = (store: IState): boolean => getChangeRequestsState(store).loading;
export const getChangeRequestsLoaded = (store: IState): boolean => getChangeRequestsState(store).loaded;
export const getChangeRequestsError = (store: IState): string => getChangeRequestsState(store).error;
